import GO, { Size } from "gojs";
import Vue from "vue";
const go = GO;
const $ = go.GraphObject.make;
const goMake = GO.GraphObject.make;
// const goMake = go.GraphObject.make;
const defaultFontStyle = "bold 14px 'fontello', 'Pretendard', 'NanumSquare', sans-serif";
const NodeTextBlockStyle = (text={}) => {
  return goMake(GO.TextBlock, 
    Object.assign(
    {
      row: 0, column: 3,
      editable: false,
      maxLines: 2,
      margin: 4,
      stroke: '#fff',
      background: 'transparent',
      textAlign: "center",
      font: defaultFontStyle,
      //maxSize: new GO.Size(80, NaN),
      overflow: GO.TextBlock.OverflowEllipsis,
    }, text),
    new GO.Binding("text") ,
  )
}

// 노드에 넣을 그림의 경로 객체.
const imageSource = {
  MATERIAL      : require(`@assets/protocol/Material.png`),
  PROCESS       : require(`@assets/protocol/Process.png`),
  MEASUREMENT   : require(`@assets/protocol/Measurement.png`),
  ANALYSIS      : require(`@assets/protocol/Analysis.png`),
  EQUIPMENT     : require(`@assets/protocol/Equipment.png`),
  // PROTOCOL      : require(`@assets/protocol/PROTOCOL.png`),
  PROTOCOL      : "",
};

const NodeDefaultStyle = (shape={}, text={}, obj = {}, nodeGbn)=> {
  text.toolTip = goMake("ToolTip",
  goMake( go.TextBlock,
      {margin:4},
      new go.Binding("text","",(node)=> {return node.text})
    )
  )

  const imageSrc = imageSource[nodeGbn];

    return [
        goMake(GO.Panel, 'Auto',
            {minSize: new GO.Size(120, 33),},
            goMake(GO.Shape,
                Object.assign({
                    name: 'TargetNode',
                    // geometryString:'M16.5 0h55s16.5 0 16.5 16.5v0s0 16.5 -16.5 16.5h-55s-16.5 0 -16.5 -16.5v0s0 -16.5 16.5 -16.5',
                    stroke: '#fff',
                    fill: '#fff',
                    portId: '',
                    fromLinkable: true,
                    toLinkable: true,
                    mouseEnter: (e, node) => {
                        node.toLinkable = false
                        node.fromLinkable = false
                    },
                    mouseLeave: (e, node) => {
                        node.toLinkable = true
                        node.fromLinkable = true
                    },
                }, shape)),

            goMake(go.Panel, 'Table', {},
                goMake(go.Picture, imageSrc,
                    {
                        row: 0,
                        column: 2,
                        maxSize: new go.Size(16, 16),
                        margin: new go.Margin(0, 0, 0, 0),
                        imageStretch: go.GraphObject.Fill,
                    },
                ),

                nodeGbn == "MATERIAL" ?
                    goMake(go.Picture,
                        {
                            row: 0,
                            column: 4,
                            maxSize: new go.Size(16, 16),
                            margin: new go.Margin(0, 5, 0, 0),
                            imageStretch: go.GraphObject.Fill,
                        },
                        new go.Binding("source", "shape", (v) => {
                            return require(`@/assets/protocol/${v}.png`);
                        })
                    ) : {},

                NodeTextBlockStyle(text),
                //노드 순서
                goMake(go.Panel,
                    {
                        row: 0
                        , column: 1
                    },
                    goMake(go.Panel, "Auto",  // "Auto" 패널을 사용해 TextBlock을 Shape로 감쌉니다.
                        {
                            //row: 0, column: 1,  // TextBlock과 동일한 위치
                            margin: new go.Margin(0, 5, 0, 10),
                        },
                        // 네모 테두리 Shape
                        goMake(go.Shape, {
                            figure: "RoundedRectangle",  // 네모 모양
                            fill: "#ffffff",  // 배경색 (투명)
                            stroke: "#19A4AD",       // 테두리 색
                            strokeWidth: 1,     // 테두리 두께
                            name: "borderShape",  // 이름 설정 (필요 시 액세스 가능)
                            parameter1: 3,               // 둥근 모서리 반경 (값을 조정해 둥근 정도를 설정)
                            },
                            new go.Binding("stroke", "nodeForceOrder", (nodeForceOrder) => {
                                let path = '';
                                path = window.location.pathname;
                                if (nodeForceOrder!= null && nodeForceOrder > 0 && path.includes('process/editor')) {
                                    return "#F24F43"
                                }else{
                                  return "#19A4AD"
                                }
                            }),  // 바인딩
                        ),
                        // 텍스트 블록
                        goMake(go.TextBlock, {
                                text: "-",  // 기본 텍스트
                                editable: false,
                                maxLines: 2,
                                margin: new go.Margin(1, 2, 1, 2),
                                stroke: 'black',
                                background: 'transparent',
                                textAlign: "center",
                                font: "bold 10px sans-serif", // 폰트 크기 축소
                                maxSize: new GO.Size(60, NaN), // 텍스트 블록 크기 축소
                                overflow: GO.TextBlock.OverflowEllipsis,
                            },
                            new go.Binding("text", "nodeOrder")  // 바인딩
                        )
                    )
                ),
                // 연결 프로토콜 표시 
                goMake(go.Panel,
                    {
                        row: 0
                        , column: 5
                      , visible: false
                    },
                    goMake(go.Panel, "Auto",  // "Auto" 패널을 사용해 TextBlock을 Shape로 감쌉니다.
                        {
                            //row: 0, column: 1,  // TextBlock과 동일한 위치
                            margin: new go.Margin(0, 5, 0, 10),
                        },
                        // 네모 테두리 Shape
                        goMake(go.Shape, {
                            figure: "RoundedRectangle",  // 네모 모양
                            fill: "#ffffff",  // 배경색 (투명)
                            stroke: "#19A4AD",       // 테두리 색
                            strokeWidth: 1,     // 테두리 두께
                            name: "borderShape",  // 이름 설정 (필요 시 액세스 가능)
                            parameter1: 3,               // 둥근 모서리 반경 (값을 조정해 둥근 정도를 설정)
                        }),
                        // 텍스트 블록
                        goMake(go.TextBlock, {
                                name: "protocol",
                                text: "P-0",  // 기본 텍스트
                                editable: false,
                                maxLines: 2,
                                margin: new go.Margin(1, 2, 1, 2),
                                stroke: 'black',
                                background: 'transparent',
                                textAlign: "center",
                                font: "bold 10px sans-serif", // 폰트 크기 축소
                                maxSize: new GO.Size(60, NaN), // 텍스트 블록 크기 축소
                                overflow: GO.TextBlock.OverflowEllipsis,
                            },
                            new go.Binding("text", "protocolData", (protocolData) => {
                                let result = 0;
                                if(protocolData?.cnt > 0){
                                    result = protocolData?.cnt;
                                }
                                return "P-" + result;                                
                            })  // 바인딩
                        )
                    ),
                    new go.Binding("visible", "protocolData", (protocolData) => {
                        let result = false;
                        if(protocolData?.cnt > 0){
                            result = true;
                        }
                        return result;
                    })
                )
            ),
            obj,
        )
    ]
}
const NodeButtonStyle = (x=0, y=0, align=[0, 0, 0, 0], angle=0) => {
  return goMake(GO.Panel, 'Spot',
  {
    name: 'BUTTON', alignment: new GO.Spot(...align), opacity: 1,
    position: new GO.Point(x, y),
    angle: angle,
    portId: '',
    fromLinkable: true,
    fromSpot: GO.Spot.Top,
    click: (e, button) => console.log(e, button),
  },
  goMake(GO.Shape, 'Circle', {width: 24, height: 24, fill:'#fff', stroke:'#999'}),
  goMake(GO.Shape, 'LineUp', {width: 12, height:12, fill:'#fff', stroke:'#333'}),
  )
}
const SelectionButtonStyle = (x=0, y=0, align=[0, 0, 0, 0], angle=0) => {
  return goMake('Button', 'Spot',
  {
    name: 'BUTTON', alignment: new GO.Spot(...align), opacity: 1,
    position: new GO.Point(x, y),
    angle: angle,
    portId: '',
    fromLinkable: true,
    fromSpot: GO.Spot.Top,
    width: 24, height: 24,
    "ButtonBorder.figure": "Circle",
    "ButtonBorder.stroke": '#999',
    "ButtonBorder.fill":'#fff',
    "_buttonFillOver": "#ddd",
    click: (e, button) => {
      e.diagram.clearSelection()
      const node = button.part.adornedPart
      const tool = e.diagram.toolManager.linkingTool
      tool.startObject = node.port
      e.diagram.currentTool = tool
      tool.doActivate();
    },
    mouseHover: (e, button) => {
      // console.log(e, button);
      button["_buttonFillOver"] = '#000';
    }
  },
  goMake(GO.Shape, {
    name:'arrow', geometryString: 'M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z',
    width: 10, height:8, fill:'#333333', strokeWidth:.8, stroke:'#333',}),
  )
}
const NodeSelectionStyle = () => {
  return goMake(GO.Adornment, 'Spot',
    goMake(GO.Panel, "Auto",
      goMake( GO.Shape, 'RoundedRectangle', {
        stroke: '#999', strokeWidth: 2, strokeDashArray: [5,4], strokeDashOffset: 5,
        fill: 'transparent',
      } ),
      goMake(GO.Placeholder),
    ),
    SelectionButtonStyle(0,0,[0.5,0,0,-15], -90), //top
    SelectionButtonStyle(0,0,[1,0.5,15,0], 0), // right
    SelectionButtonStyle(0,0,[0.5,1,0,15], 90), // bottom
    SelectionButtonStyle(0,0,[0,0.5,-15,0], 180), // left
  )
}
const NodeHoverStyle = () => {
  return goMake(GO.Panel, 'Spot',
    { name:'LinkButton', visible:true, background: 'transparent'},
    goMake(GO.Panel, 'Spot', 
      { minSize: new GO.Size(140, 50), maxSize: new GO.Size(140, 60) },
      goMake( GO.Shape, 'Terminator', {
        stroke: '#999', strokeWidth: 2, strokeDashArray: [5,4], strokeDashOffset: 5,
        fill: 'transparent',
      } ),
    ),
    NodeButtonStyle(0,0,[0.5,0,0,0]), //top
    NodeButtonStyle(0,0,[1,0.5,0,0], 90), // right
    NodeButtonStyle(0,0,[0.5,1,0,0], 180), // bottom
    NodeButtonStyle(0,0,[0,0.5,0,0], 270), // left
  )
}
const ModelLoading = () => {
  return goMake(GO.Panel, 'Spot', {
      // location: new GO.Point(0,0), 
      margin: 10,
      background:'#333',
    },
    goMake(GO.TextBlock, 'Loading', {
      font:'30px sans-serif', 
    })
  );
}
export const makeNodeStyleMap = () => {
  const nodeStyleMap = new Map();

  nodeStyleMap.set('MATERIAL', {
    id: 0,
    label: "재료",
    category: "MATERIAL",
    variant: "#E6E2EC", // 색상을 코드로 넣어야함
    linkValidation: ["PROCESS", "EQUIPMENT"], // ~ 으로 연결 가능
    nodeTemplate: NodeDefaultStyle(
      { figure: 'CapsuleH',strokeWidth: 1, stroke: '#684D92', fill: '#E6E2EC' },
      { stroke: '#0D0E10', },
      goMake("Button", {
        name: "TREEBUTTON",
        alignment: go.Spot.Right,
        alignmentFocus: go.Spot.Right,
        opacity: 0,  // initially not visible
        click: function (event, button) {
            if(!button.diagram.isReadOnly) {
                // editor가 readOnly가 아닐때만 실행.
                var node = button.part; // 버튼이 속한 노드 가져오기
                var expanded = node.data.treeExpanded;
                expanded = expanded == undefined ? true : expanded;
                node.data.treeExpanded = !expanded;
                treeExpandedAction(node);
            }
        },
      },
        new go.Binding("opacity", "isSelected", (s,button) => {
            if(s){
                // 선택시 true
                if(button.diagram.isReadOnly){
                    // editor 상태가 readOnly면 해당 버튼이 보이지 않도록 한다.
                    return 0;
                }else {
                    // editor 상태가 readOnly가 아니면 해당 버튼이 보이도록 한다.
                    return 1;
                }
            }else{
                if(button.part.data.treeExpanded === false && !button.diagram.isReadOnly){
                    // 확장되어 있지 않은 상태이며 editor가 readOnly 상태가 아닐때
                    return 1;
                }
                return 0;
            }
        }).ofObject(),
        goMake(go.Shape, {
          name: "Tree"
          , figure: "PlusLine"
          , width: 10
          , height: 10
          , fill: '#fff'
          , stroke: '#999'
        },
          new go.Binding("figure", "data", function (data) {
            // 확장값이 false 또는 undifined 일때는 확장될 것이 없으니 기본값으로 minusLine을 보여주도록.
            return data.treeExpanded != false ? "MinusLine" : "PlusLine";
          }).ofObject(),
        ),
      ),
      "MATERIAL",
    ),
  })
  nodeStyleMap.set('PROCESS', {
    id: 1,
    label: "공정",
    category: "PROCESS",
    variant: "1F4B81",
    linkValidation: ["MATERIAL", "PROCESS"],
    nodeTemplate: NodeDefaultStyle(
      { figure: 'CapsuleH',strokeWidth: 1, stroke: '#0F64CE', fill: '#D8E5F5' },
      { stroke: '#3C4141', },
      {},
      "PROCESS",
    )
  })
  nodeStyleMap.set('EQUIPMENT', {
    id: 3,
    label: "측정/분석",
    category: "EQUIPMENT",
    variant: "67A1E3",
    outline: true,
    linkValidation: [], // ~ 으로 연결 가능
    nodeTemplate : NodeDefaultStyle(
        {figure: 'CapsuleH',strokeWidth: 1, stroke: '#5D9C3D',fill: '#DAEDE8'},
        {stroke: '#3C4141',},
        {},
        "EQUIPMENT",
    ),
  })

  return nodeStyleMap;
}

const makeNodeGroupStyleMap = () => {
  const nodeGroupStyleMap = new Map();

  nodeGroupStyleMap.set('SUBPROCESS', {
    id: "SUBPROCESS",
    label: "서브공정그룹",
    category: "SUBPROCESS",
  })

  nodeGroupStyleMap.set('MAINPROCESS', {
    id: "MAINPROCESS",
    label: "대표공정그룹",
    category: "MAINPROCESS",
  })

  return nodeGroupStyleMap;
}

GO.Shape.defineFigureGenerator("Terminator", function (shape, w, h) {
  var geo = new GO.Geometry();
  var fig = new GO.PathFigure(0.25 * w, 0, true);
  geo.add(fig);

  fig.add(new GO.PathSegment(GO.PathSegment.Arc, 270, 180, 0.75 * w, 0.5 * h, 0.25 * w, 0.5 * h));
  fig.add(new GO.PathSegment(GO.PathSegment.Arc, 90, 180, 0.25 * w, 0.5 * h, 0.25 * w, 0.5 * h));
  geo.spot1 = new GO.Spot(0.23, 0);
  geo.spot2 = new GO.Spot(0.77, 1);
  return geo;
});

go.Shape.defineFigureGenerator("CapsuleH", function(shape, w, h) {
  const geo = new go.Geometry();
  if (w < h) {
    const fig = new go.PathFigure(w/2, 0, true);
    fig.add(new go.PathSegment(go.PathSegment.Bezier, w/2, h, w, 0, w, h));
    fig.add(new go.PathSegment(go.PathSegment.Bezier, w/2, 0, 0, h, 0, 0));
    geo.add(fig);
    return geo;
  } else {
    const fig = new go.PathFigure(h/2, 0, true);
    geo.add(fig);
    // Outline
    fig.add(new go.PathSegment(go.PathSegment.Line, w-h/2, 0));
    fig.add(new go.PathSegment(go.PathSegment.Arc, 270, 180, w-h/2, h/2, h/2, h/2));
    fig.add(new go.PathSegment(go.PathSegment.Line, w-h/2, h));
    fig.add(new go.PathSegment(go.PathSegment.Arc, 90, 180, h/2, h/2, h/2, h/2));
    return geo;
  }
});
go.Shape.defineFigureGenerator("Capsule", "CapsuleH");  // synonym

go.Shape.defineFigureGenerator("Protocol", function(shape, w, h) {
  const geo = new go.Geometry();
  const fig = new go.PathFigure(0, 0, false);
  fig.add(new go.PathSegment(go.PathSegment.Line, 0, h));
  geo.add(fig);
  return geo;
});

go.Shape.defineFigureGenerator('FivePointedStar', (shape, w, h) => {
  const starPoints = createStar(5);
  const geo = new go.Geometry();
  const fig = new go.PathFigure(starPoints[0].x * w, starPoints[0].y * h, true);
  geo.add(fig);

  for (let i = 1; i < 10; i++) {
    fig.add(new go.PathSegment(go.PathSegment.Line, starPoints[i].x * w, starPoints[i].y * h));
  }
  fig.add(new go.PathSegment(go.PathSegment.Line, starPoints[0].x * w, starPoints[0].y * h).close());
  freeArray(starPoints);
  geo.spot1 = new go.Spot(.266, .333);
  geo.spot2 = new go.Spot(.733, .733);
  return geo;
});


// 하위 노드중 공정 재료를 제외한 노드를 접는 function.
function treeExpandedAction(currentNode) {
  let onlyProcessFlag = false;
  let childNodes = new go.Set();
  findChildNodes(currentNode, childNodes);
  if(childNodes.size == 0){
      // 하위 노드중 접을게 없다면 확장값을 true(확장상태)로 세팅.
      currentNode.data.treeExpanded = true;
      onlyProcessFlag = true;
  }
  childNodes.each(function (node) {
      node.visible = currentNode.data.treeExpanded;
  });
  // 버튼 모양 업데이트
  const button = currentNode.findObject("Tree");
  if (button) {
      if(!onlyProcessFlag){
          // 확장될 값이 존재할때만 하위 코드 실행
          button.figure = currentNode.data.treeExpanded ? "MinusLine" : "PlusLine";
      }
  }
}

// 재귀 함수를 사용한 하위 노드 탐색. 공정, 재료 하위는 제외
function findChildNodes(currentNode,childNodes){
    let links = currentNode.findLinksOutOf();
    links.each(function (link) {
        let targetNode = link.toNode;
        if(!(targetNode.data.category == "PROCESS" || targetNode.data.category == "MATERIAL")){
            childNodes.add(targetNode);
            findChildNodes(targetNode,childNodes)
        }
    });
}

const _CachedArrays = [];
/**
 * @ignore
 * @param {Array} a
 */
function freeArray(a) {
    a.length = 0; // clear any references to objects
    _CachedArrays.push(a);
}

/**
 * @ignore
 * This allocates a temporary Array that should be freeArray()'ed by the caller.
 * @param {number} points
 * @return {Array}
 */
function createStar(points) {
    // First, create a regular polygon
    const polygon = createPolygon(points);
    // Calculate the points inbetween
    const pts = tempArray(); // new Point[points * 2 + 1];
    const half = Math.floor(polygon.length / 2);
    const count = polygon.length - 1;
    const offset = (points % 2 === 0) ? 2 : 1;
    for (let i = 0; i < count; i++) {
        // Get the intersection of two lines
        const p0 = polygon[i];
        const p1 = polygon[i + 1];
        const q21 = polygon[(half + i - 1) % count];
        const q2off = polygon[(half + i + offset) % count];
        pts[i * 2] = p0;
        pts[i * 2 + 1] = getIntersection(p0.x, p0.y, q21.x, q21.y, p1.x, p1.y, q2off.x, q2off.y, new go.Point()); // ?? not currently managed
    }
    pts[pts.length] = pts[0];
    freeArray(polygon);
    return pts;
}

/**
 * @ignore
 * This allocates a temporary Array that should be freeArray()'ed by the caller.
 * @param {number} sides
 * @return {Array}
 */
function createPolygon(sides) {
    // Point[] points = new Point[sides + 1];
    const points = tempArray();
    const radius = .5;
    const center = .5;
    const offsetAngle = Math.PI * 1.5;
    let angle = 0;
    // Loop through each side of the polygon
    for (let i = 0; i < sides; i++) {
        angle = 2 * Math.PI / sides * i + offsetAngle;
        points[i] = new go.Point((center + radius * Math.cos(angle)), (center + radius * Math.sin(angle)));
    }
    // Add the last line
    // points[points.length - 1] = points[0];
    points.push(points[0]);
    return points;
}

/**
 * @ignore
 * @return {Array}
 */
function tempArray() {
    const temp = _CachedArrays.pop();
    if (temp === undefined)
        return [];
    return temp;
}

/**
 * @ignore
 * @param {number} p1x
 * @param {number} p1y
 * @param {number} p2x
 * @param {number} p2y
 * @param {number} q1x
 * @param {number} q1y
 * @param {number} q2x
 * @param {number} q2y
 * @param {Point} result
 * @return {Point}
 */
function getIntersection(p1x, p1y, p2x, p2y, q1x, q1y, q2x, q2y, result) {
    const dx1 = p1x - p2x;
    const dx2 = q1x - q2x;
    let x;
    let y;
    if (dx1 === 0 || dx2 === 0) {
        if (dx1 === 0) {
            const m2 = (q1y - q2y) / dx2;
            const b2 = q1y - m2 * q1x;
            x = p1x;
            y = m2 * x + b2;
        }
        else {
            const m1 = (p1y - p2y) / dx1;
            const b1 = p1y - m1 * p1x;
            x = q1x;
            y = m1 * x + b1;
        }
    }
    else {
        const m1 = (p1y - p2y) / dx1;
        const m2 = (q1y - q2y) / dx2;
        const b1 = p1y - m1 * p1x;
        const b2 = q1y - m2 * q1x;
        x = (b2 - b1) / (m1 - m2);
        y = m1 * x + b1;
    }
    result.x = x;
    result.y = y;
    return result;
}

export default Vue.extend({
  data() {
    return {
      // diagram 속성 템플릿
      diagramTemplate: {
        layout: $(go.LayeredDigraphLayout, {isOngoing: false}),
        // layout: $(go.TreeLayout),
        "undoManager.isEnabled": true,
      },
      // element category에 따른 node 템플릿 등
      nodeStyle: {
        default : NodeDefaultStyle,
        textBlock: NodeTextBlockStyle,
        button : NodeButtonStyle,
        selectionButton : SelectionButtonStyle,
        selection : NodeSelectionStyle,
        hover : NodeHoverStyle,
        modelLoading : ModelLoading,
        fontStyle : defaultFontStyle
      },
      nodeStyleMap: makeNodeStyleMap(),
      nodeGroupStyleMap: makeNodeGroupStyleMap(),
      linkTemplate: goMake(
        GO.Link,
        {
          reshapable: false,
          // fromSpot: go.Spot.Right,
          // toSpot: go.Spot.Left,
          routing: go.Link.AvoidsNodes,
          corner: 10,
        },
        new go.Binding("points").makeTwoWay(),
        goMake(GO.Shape, { isPanelMain: true, stroke: "transparent", strokeWidth: 5}), //링크선의 클릭 영역 확장을 위한 투명선
        goMake(GO.Shape, { isPanelMain: true, stroke: "#aaaaaa" }),
        goMake(GO.Shape, { toArrow: "Feather", stroke: "#aaaaaa", fill: null }),
      ),
    };
  },
  methods: {
    //GoJS 객체는 한 패널에만 속할 수 있어, 템플릿을 다시 만들 때는 새 인스턴스가 필요하다.
    refreshNodeStyleMap() {
      this.nodeStyleMap = makeNodeStyleMap();
      return this.nodeStyleMap;
    },
    //하나의 DOM 요소에는 하나의 Diagram만 붙을 수 있어,
    //다시 그리기 전에 이전 Diagram/Overview 를 해당 요소에서 떼어낸다.
    //(떼어내지 않으면 "div already has a Diagram associated with it" 오류가 발생한다.)
    releaseDiagram(div) {
      if (this.overview instanceof GO.Diagram) {
        this.overview.div = null;
        this.overview = null;
      }
      if (this.diagram instanceof GO.Diagram) {
        this.diagram.div = null;
        this.diagram = null;
      }
      //컴포넌트가 참조를 잃은 뒤에도 요소에 Diagram 이 남아있을 수 있어 한 번 더 정리한다.
      if (div && div.goDiagram instanceof GO.Diagram) {
        div.goDiagram.div = null;
      }
    },
  },
});
